"use client";

import { useCallback } from "react";
import cx from "classnames";
import { deleteCompareVehicle, setCompareVehicle, useCompareVehicles } from "@/hooks/useCompares";
import { Vehicle } from "@/types/vehicle";
import Checkbox from "../../checkbox";
import { Translations } from "@/utils/translations";
import { getTranslationModule } from "@/utils/translations";
import styles from "./styles.module.scss";

interface ICarCompareCheckbox {
  vehicle: Vehicle;
  className?: string;
  translations: Translations;
  hideTitle?: boolean;
}

export default function CarCompareCheckbox({ vehicle, className, translations, hideTitle }: ICarCompareCheckbox) {
  const compareList = useCompareVehicles();
  const t = getTranslationModule(translations, "common");
  const checked = compareList.some((item) => vehicle.id === item);
  const onChange = useCallback(
    (value: boolean) => {
      if (value) {
        setCompareVehicle(vehicle.id);
      } else {
        deleteCompareVehicle(vehicle.id);
      }
    },
    [vehicle.id],
  );

  return (
    <Checkbox
      option={hideTitle ? "" : t("compares")}
      onChanged={onChange}
      checked={checked}
      disabled={compareList.length >= 4 && !checked}
      className={cx(styles.checkbox, className)}
    />
  );
}
